// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1ygv4","clinicsSelect":"TableHeading_clinicsSelect__2tPpU"};